import { useEffect, useRef } from "react"
import { graphql, GraphQLSubscriptionConfig, OperationType, requestSubscription } from "relay-runtime"
import {
  useSlotUpdatedSubscription$data,
  WaitingRoomAppointmentsInput,
} from "@/modules/waiting-room/services/__generated__/useSlotUpdatedSubscription.graphql"
import { RelayEnvironment } from "@/relay-environment"

export const slotUpdatedSubscription = graphql`
  subscription useSlotUpdatedSubscription($filters: WaitingRoomAppointmentsInput) {
    schedulingPlanChanged(waitingRoomAppointmentsInput: $filters) {
      id
      slotId
      appointments {
        id
        ...appointmentRow_WaitingRoomAppointment
        ...appointmentDrawerData_WaitingRoomAppointment
        ...appointmentSearch_WaitingRoomAppointment
      }
    }
  }
`

const useSlotUpdatedSubscription = (filters: WaitingRoomAppointmentsInput) => {
  const disposeRef = useRef<() => void>(undefined)

  useEffect(() => {
    if (!filters?.dateRange) {
      const config: GraphQLSubscriptionConfig<OperationType & { response: useSlotUpdatedSubscription$data }> = {
        variables: {
          filters,
        },
        subscription: slotUpdatedSubscription,
        onError: (error: Error) =>
          console.error(`An error occurred while establishing connection for slotUpdated subscription`, error),
        onCompleted: () => console.info("Server closed subscription"),
        cacheConfig: { metadata: { sensitive: true } },
      }

      const { dispose } = requestSubscription(RelayEnvironment, config)
      disposeRef.current = dispose
    }

    return () => {
      if (disposeRef.current) {
        disposeRef.current()
        disposeRef.current = undefined
      }
    }
  }, [filters, disposeRef])
}

export { useSlotUpdatedSubscription }
